import {html, safeHtml} from "common-tags";

import {AddressBlock} from "./interfaces";
import {dealerCleanup} from "./helpers";

export const addressBlock: AddressBlock = (
  dealer,
  selected = false,
  active = false,
  marker = null,
  labelSelectedOnMap = "",
) => {
  dealer = dealerCleanup(dealer)

  const inner = html`
    <label class="selected-on-map">${labelSelectedOnMap}</label>
    <strong class="name">${dealer.name}</strong>
    <p class="address">${dealer.full_address}</p>
  `

  if (selected) {
    return inner
  }

  return html`
    <address class="card mb-1 select-address ${active ? "_active" : ""}"
             data-js="dsp-select-address"
             data-address-id="${dealer.id}"
             data-dealer-name="${dealer.name}"
             data-dealer-address="${dealer.full_address}"
             data-marker="${marker}">
      ${inner}
    </address>
  `
}

export const infoBlock = (
  loading = true,
  text = "",
) => {
  return safeHtml`
      <div class="card mb-1 info-block">
        <div class="icon">
          <i class="fal ${loading ? "fa-spinner fa-spin" : "fa-info-circle"}"></i>
        </div>
        <p>${text}</p>
      </div>
    `
}
